import React from "react";
import { NavLink } from "react-router-dom";
import { Button, Grid, Typography } from "@material-ui/core";

const registerWithPaydirectLink = React.forwardRef((props, ref) => (
    <NavLink innerRef={ref} to="/migrate-business/paydirect" {...props} />
));
const registerWithAutopayLink = React.forwardRef((props, ref) => (
    <NavLink innerRef={ref} to="/migrate-business/autopay" {...props} />
));
const registerNewUserLink = React.forwardRef((props, ref) => (
    <NavLink innerRef={ref} to="/register" {...props} />
));

export default function RegisterLinks(props) {
    const { classes } = props;

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Typography component="div">
                    <Grid container spacing={1} justify="center">
                        <Grid item md={10} sm={9} xs={12}>
                            <Button
                                fullWidth
                                color="secondary"
                                component={registerNewUserLink}
                                className={`btn form_btn ${classes.createBtn}`}
                                variant="contained"
                            >
                                New Quickteller for Business User
                            </Button>
                        </Grid>
                        <Grid item md={10} sm={9} xs={12}>
                            <Button
                                fullWidth
                                component={registerWithAutopayLink}
                                className={`btn black_btn form_btn ${classes.createBtn}`}
                                variant="contained"
                            >
                                Register with AutoPAY
                            </Button>
                        </Grid>

                        <Grid item md={10} sm={9} xs={12}>
                            <Button
                                fullWidth
                                component={registerWithPaydirectLink}
                                className={`btn dark_blue_btn form_btn ${classes.createBtn}`}
                                variant="contained"
                            >
                                Register with PAYDirect
                            </Button>
                        </Grid>
                    </Grid>
                </Typography>
            </Grid>
        </React.Fragment>
    );
}
